import React from 'react'
import { Button } from '@mui/material'
import PaymentConfigForm from './PaymentConfigForm'
import PaymentConfigMenu from './PaymentConfigMenu'

/**
 * Example usage of PaymentConfigForm and PaymentConfigMenu components
 * This component can be used in different contexts by passing appropriate entityId and entityType
 */

// Example 1: For a Mentor
export const MentorPaymentConfig = ({ mentorId }) => {
  return <PaymentConfigForm entityId={mentorId} entityType="mentor" />
}

// Example 2: For a Clinic
export const ClinicPaymentConfig = ({ clinicId }) => {
  return <PaymentConfigForm entityId={clinicId} entityType="clinic" />
}

// Example 3: For a Company
export const CompanyPaymentConfig = ({ companyId }) => {
  return <PaymentConfigForm entityId={companyId} entityType="company" />
}

// Example 4: Generic usage without props (will allow user to input entityId and entityType)
export const GenericPaymentConfig = () => {
  return <PaymentConfigForm />
}

// Example 5: Payment Config Menu with Dialog (Recommended Usage)
export const PaymentConfigMenuWithDialog = ({ payoutEntityId, payoutEntityType, entityName }) => {

  return (
    <PaymentConfigMenu
      payoutEntityId={payoutEntityId}
      payoutEntityType={payoutEntityType}
      entityName={entityName}
      showPaymentConfigButtons={true}
    />
  )
}

// Example 6: How to replace the original two buttons with the menu + dialog
export const ReplacementExample = ({
  payoutEntityId,
  payoutEntityType,
  showPaymentConfigButtons,
}) => {

  return (
    <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
      {/* Other buttons in your toolbar */}
      <Button variant="outlined">Some Other Action</Button>

      {/* Replace the two separate buttons with the menu that opens a dialog */}
      <PaymentConfigMenu
        payoutEntityId={payoutEntityId}
        payoutEntityType={payoutEntityType}
        showPaymentConfigButtons={showPaymentConfigButtons}
      />

      {/* This completely replaces the original implementation: */}
      {/* 
      {showPaymentConfigButtons && (
        <>
          <Button
            sx={{ flexShrink: 0 }}
            variant="contained"
            onClick={() =>
              onPaymentConfigClick({ entityId: 'AUMHUM', entityType: 'company' })
            }
          >
            Source Payment Config
          </Button>
          <Button
            sx={{ flexShrink: 0 }}
            variant="contained"
            onClick={() =>
              onPaymentConfigClick({
                entityId: reportsListingApiParams?.['teacher-id'],
                entityType: 'mentor',
              })
            }
          >
            Practitioner Payment Config
          </Button>
        </>
      )}
      */}
    </div>
  )
}

// Example 7: Standalone form usage (without dialog)
export const StandaloneFormUsage = () => {
  const handleFormSaved = () => {}

  return <PaymentConfigForm entityId="mentor123" entityType="mentor" onSaved={handleFormSaved} />
}

export default PaymentConfigForm
